import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Component from "src/components/Component";
import Page from "src/components/Page";
import withAppContext from "src/components/withAppContext";
import withAxios from "src/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Modal, Backdrop, Button, Fade } from '@material-ui/core';
import { styles } from "./styles";
import { IDirectorSettingsState, IProps } from "./types";
import { Link } from "react-router-dom";
import moment from "moment";
import { FILE_URL, ZENDESK_CANCEL_SUBSCRIPTION } from "src/constants";
import ViewModal from "src/components/ViewModal";
import PlanOptions from "src/components/PlanOptions";
import CancelModal from "src/components/CancelModal";

export default withAppContext(
  withSchoolContext(
    withStyles(styles)(
      withAxios(
        class extends Component<IProps, IDirectorSettingsState> {
          public readonly state = this.buildState({
            loader: false,
            subscriptionHistory: [],
            activePlan: null,
            showSubscription: false,
            modalVisible: false,
            modalContent: {},
            upgradePlan: false,
            showDescription: false,
            showCancelModal: false,
            description: []
          });

          public componentDidMount(): void {
            const showSubscription = this.props.userSubscription?.plans?.id === 1 ? true : false
            this.setState({ showSubscription })
            localStorage.removeItem('upgradeDetails');
            this.props.loadUserSubscription()
            this.getHistoryHandler()
            console.log("school props====>", this.props.school)

          }

          public getPurchasableAddonsByPlanId(planid: any) {
            // Returns addon IDs that can be purchased separately (NOT included by default)
            switch (planid) {
              case 2:
                return [1, 2, 3, 4]
              case 3:
                return [2, 3, 4]
              case 4:
                return [3, 4]
              case 5:
                return [4]
              default:
                return []
            }
          }


          public async getHistoryHandler() {
            this.setState({ loader: true })
            const res: any = await this.buildGet(this, "payment/getPlanHistory/" + this.props.school.id)()
            console.log("getPlanHistory=====>", res)
            if (res?.status) {
              if (res?.data?.length > 0) {
                if (res?.data?.membership?.memberPayHistory?.status === 'active') {
                  const activePlan = res?.data?.membership?.memberPayHistory?.plan || null
                  this.setState({ activePlan })
                } else {
                  this.setState({ activePlan: null })
                }

                this.setState({ subscriptionHistory: res?.data })

              } else {
                this.setState({ activePlan: null })
              }
            } else {
              this.setState({ activePlan: null })
            }
          }

          public changeChequeName = (value: string) => {
            if (value === 'Cheque' || value === 'cheque') {
              return 'Check'
            }
            return value
          }

          public CFS(text: any = "") {
            return text
              ?.split(/([.!?]\s+)/) // Split by sentence-ending punctuation followed by space.
              ?.map((sentence: any) => sentence?.charAt(0)?.toUpperCase() + sentence?.slice(1))
              ?.join('');
          }

          public async getAllPlanHandler() {
            // this.setState({ loader: true })
            const tempDataAddon = this.props.userSubscription?.addon?.map((item: any) => item.addon)
            const tempData = tempDataAddon?.map((item: any) => item.id) || []
            const memberShipId = this.state.subscriptionHistory[0].membership?.id
            localStorage.setItem("upgradeDetails", JSON.stringify({ plan: this.props.userSubscription?.plans, addon: tempDataAddon, addonId: tempData, memberShipId, isStripe: (this.state.subscriptionHistory.length > 0 && this.state.subscriptionHistory[0]?.membership?.subscription_type === "stripe") ,onlyBuyAddon:false }));
            this.props.history.push(`/${this.props.school?.slug}/purchase-plan`)

          }

          public paymentCardChange = async () => {
            this.setState({ loader: true, })
            const memberShipId = this.state.subscriptionHistory[0].membership?.id
            const paymentData = {
              "membership_id": memberShipId,
            }
            const res: any = await this.buildPut(this, "payment/cardUpdate")(paymentData)
            console.log("cardUpdate", res?.data)
            if (res?.status) {
              this.setState({ loader: false, })
              // this.setState({ paymentDetails: res?.data ,loader: false,})
              // window.open(res?.data?.payment_url, '_blank');
              window.location.href = res?.data?.payment_url
            } else {
              this.setState({ loader: false, })
            }
            // void this.runCancellableStatefulAsync(
            //   this,
            //   {
            //     loader: true,
            //   },
            //   {
            //     loader: false,
            //   },
            //   async () => {
            //     if (this.state.loader === false) {
            //       return;
            //     }

            //     const memberShipId = this.state.subscriptionHistory[0].membership?.id
            //     const paymentData = {

            //       "membership_id": memberShipId,
            //     }
            //     const res: any = await this.buildPost(this, "payment/cardUpdate")(paymentData)
            //     console.log("cardUpdate", res?.data)
            //   },
            //   () => {
            //     // Do nothing
            //     this.setState({
            //       loader: false,
            //     });
            //   }
            // );
          }

          public isPlanExpired(planEndDate: any) {
            // Convert planEndDate to a moment object
            const endDate = moment(planEndDate, 'MM/DD/YYYY');

            // Check if today is after the endDate + 30 days
            const expired = moment().isAfter(endDate.add(30, 'days'));

            return expired;
          }

          public storeOldPlanDetails = () => {
            // Store old plan details in localStorage
            const tempDataAddon = this.props.userSubscription?.addon?.map((item: any) => item.addon) || [];
            const addonTotal = tempDataAddon.reduce((sum: number, item: any) => sum + (Number(item?.price) || 0), 0);
            const planPrice = Number(this.props.userSubscription?.plans?.price) || 0;
            
            const oldPlanDetails = {
              plan: this.props.userSubscription?.plans,
              planPrice,
              addons: tempDataAddon,
              addonPrice: addonTotal,
              totalPrice: planPrice + addonTotal,
              membership: this.state.subscriptionHistory[0]?.membership,
              subscriptionDate: this.state.subscriptionHistory[0]?.membership?.memberPayHistory?.subscriptionDate,
              validUpto: this.state.subscriptionHistory[0]?.membership?.memberPayHistory?.validUpto,
            };
            
            localStorage.setItem("oldplandetails", JSON.stringify(oldPlanDetails));
          }

          public render() {
            const {
              appContext: { user, baseUri },
              classes,
              school
            } = this.props;
            console.log(user, classes, baseUri)

            return (
              <Page
                header={'Subscription'}
                subtitle={''}
              >
                <div>
                <div>

               
                  {(this.props.school?.isAdSurvey=== false && this.props.school?.ismidseason === false) && (
  this.state.showSubscription ? (
    <div className="buy-now-div" style={{ float: 'right', marginTop: "10px" }}>
      <Link to={`/${school?.slug}/upgrade-subscription?membership_id=${this.state.subscriptionHistory[0]?.membership?.id}`}>
        <button className="upgrade-subscription-btn" onClick={this.storeOldPlanDetails}>
          <span>Upgrade Subscription</span>
        </button>
      </Link>
    </div>
  ) : (
    <div className="buy-now-div" style={{ float: 'right', marginTop: "10px" }}>
      <Link to={`/${school?.slug}/plan-details?membership_id=${this.state.subscriptionHistory[0]?.membership?.id}`}>
        <button className="upgrade-subscription-btn" onClick={this.storeOldPlanDetails}>
          <span>Upgrade Subscription</span>
        </button>
      </Link>
    </div>
  )
)}


                  {((this.props.school?.isAdSurvey=== false && this.props.school?.ismidseason === false) && (this.state.subscriptionHistory.length > 0 
                  && this.state.subscriptionHistory[0]?.membership?.subscription_type === "stripe")
              //      || 
              //  this.state.subscriptionHistory[0]?.membership?.subscription_no !== null || "" 
               ) && <div className="buy-now-div" style={{ float: 'right' }}>
                      {/* <Link to={`/${school?.slug}/upgrade-subscription`}> */}
                      <button className="upgrade-subscription-btn"
                        style={{ marginTop: "10px" }} onClick={() => {
                          this.paymentCardChange()
                        }}><span>Update Payment Information</span></button>
                      {/* </Link> */}
                    </div>}
                  </div>


                  <div>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow className="customTableHead">
                            <TableCell>Plan</TableCell>
                            <TableCell>Add-Ons</TableCell>
                            <TableCell>Cost</TableCell>
                            <TableCell>Payment Type</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>Renewal Date</TableCell>
                            {/* <TableCell>Payment status</TableCell> */}

                            <TableCell />
                            <TableCell />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.subscriptionHistory.length > 0 && this.state.subscriptionHistory?.map((row: any, index: number) => {
                            const addon = row?.addon?.length > 0 ? "Yes" : "No"
// Get base payment object (as before)
// Correct actual payment object
const rawPayment =
  row?.payment?.length > 0 ? row.payment[0].payment : {};

// Get the plan ID for this subscription
const planId = row?.membership?.memberPayHistory?.plan?.id;
// Get addon IDs that can be purchased separately for this plan (NOT included by default)
const purchasableAddonIds = this.getPurchasableAddonsByPlanId(planId);

// Calculate addon total
let addonTotal = 0;
if (Array.isArray(row?.addon)) {
  // Remove duplicates based on addon price
  const uniqueAddons = row.addon.filter((item: any, index: number, self: any[]) =>
    index === self.findIndex((t: any) => Number(t?.price) === Number(item?.price))
  );
  
  // Only include addons that were purchased separately (exclude free/included addons)
  const paidAddons = uniqueAddons.filter((item: any) => purchasableAddonIds.includes(item?.addon?.id));
  
  addonTotal = paidAddons.reduce(
    (sum: number, item: any) => sum + (Number(item?.price) || 0),
    0 as number
  );
}

console.log("Calculated addonTotal:", addonTotal);

// Plan amount
const planPrice =
  Number(row?.membership?.memberPayHistory?.price) ||
  // Number(row?.membership?.memberPayHistory?.plan?.price) ||
  0;
  console.log("planPrice", planPrice)

// Final override
const finalAmount = planPrice + addonTotal;
console.log("Calculated finalAmount:", finalAmount);
// Build final shown payment object
const payment = {
  ...rawPayment, // ensures payment_method remains available
  payment_amount: finalAmount,
  addonTotal,
  planPrice,
  finalAmount,
};
                           

                            const select = JSON.parse(row?.membership?.memberPayHistory?.plan.select)
                            return (
                              <TableRow key={index}>
                                <TableCell>

                                  <div>
                                    <div onClick={() => {
                                      this.setState({ showDescription: true, description: select })
                                    }}>{row?.membership?.memberPayHistory?.plan?.title}</div>

                                  </div>

                                </TableCell>
                                <TableCell>{addon}</TableCell>
                                <TableCell>
                                  {payment?.payment_method === "free"
                                    ? "$0.00"
                                    : payment?.payment_method === "cheque"
                                      ? `$${(payment?.payment_amount || 0).toFixed(2)}`
                                      : `$${((payment?.payment_amount || 0) * 1.03).toFixed(2)}`}
                                </TableCell>

                                <TableCell>{this.changeChequeName(this.CFS(payment?.payment_method))}</TableCell>
                                <TableCell>{moment((row?.membership?.memberPayHistory?.subscriptionDate?.split("T")[0]),"YYYY-MM-DD").format('MM/DD/YYYY')}</TableCell>
                                <TableCell>{moment((row?.membership?.memberPayHistory?.validUpto?.split("T")[0]),"YYYY-MM-DD").format('MM/DD/YYYY')}</TableCell>
                                {/* <TableCell>{moment(row?.membership?.memberPayHistory?.subscriptionDate).format('MM/DD/YYYY')}</TableCell>
                                <TableCell>{moment(row?.membership?.memberPayHistory?.validUpto).format('MM/DD/YYYY')}</TableCell> */}
                                <TableCell
                                >
                                  {payment?.checkstatus === true ? (() => {
                                    try {
                                      const resultData = JSON.parse(payment?.result_data);
                                      return (
                                        <a className="decorationNone" href={FILE_URL + "/" + resultData?.invoice} target="_blank" rel="noopener noreferrer"
                                        >
                                          <div className="upgrade-subscription-btns"
                                            style={{ width: "100px", height: "36px", textAlign: "center", lineHeight: "33px", paddingRight: "7px" }}
                                          >&nbsp; {"View Invoice"}</div>
                                        </a>
                                      );
                                    } catch (error) {
                                      // console.error("Failed to parse JSON or construct URL", error);
                                      return null;
                                    }
                                  })() : 'Pending'}
                                </TableCell>

                                <TableCell ><a href={FILE_URL + "/" + payment?.agreement} target="_blank" rel="noopener noreferrer" className="upgrade-subscription-btn"
                                  style={{ width: '500px' }}>
                                  <div className="upgrade-subscription-btns"
                                    style={{ width: "180px", height: "36px", textAlign: "center", lineHeight: "33px", marginTop: "20px", paddingRight: "8px" }}
                                  >&nbsp; {"View Terms and conditions"}</div>
                                </a></TableCell>
                                <TableCell
                                  style={{ padding: "10px" }}>
                                  <div className="active-btn"
                                    style={{ display: "flex" }}>
                                    <button
                                      className="upgrade-subscription-btnss"
                                      style={{ width: "110px", height: "36px", margin: "8px 37px 10px 10px" }}
                                      onClick={() =>
                                        this.setState({
                                          modalVisible: true,
                                          modalContent: { ...row, purchasableAddonIds },
                                        })
                                      }
                                    >
                                      View Plan
                                    </button>

                                    {(this.props.school?.isAdSurvey=== false && this.props.school?.ismidseason === false) && (row?.membership?.memberPayHistory?.plan?.id !== 1 && row?.membership?.memberPayHistory?.plan?.id !== 5) && <button
                                      className="upgrade-subscription-btnss"
                                      style={{ width: "110px", height: "36px", margin: "8px" }}
                                      onClick={() =>{
                                        localStorage.setItem("upgradeDetails", JSON.stringify({ plan: this.props.userSubscription.plans,onlyBuyAddon:true }));
                                        this.props.history.push(`/${this.props.school.slug}/addon-details?membership_id=${this.state.subscriptionHistory[0]?.membership?.id}`)
                                      }
                                        // window.open(ZENDESK_PARENT_SERVEY)
                                      }
                                    >
                                      Buy Add-Ons
                                    </button>}
                                    {this.isPlanExpired(moment(row?.membership?.memberPayHistory?.validUpto).format('MM/DD/YYYY')) && <button
                                      className="upgrade-subscription-btnss"
                                      style={{ width: "110px", height: "36px", margin: "8px" }}
                                      onClick={() =>
                                        this.getAllPlanHandler()
                                      }
                                    >
                                      Renew
                                    </button>}
                                  </div>
                                </TableCell>

                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>

                   


                  </div>
                  <div className="buy-now-div cancel-subscriptiohn-btn" style={{ marginTop: '20px' }} >
                    {/* <a
                      href={ZENDESK_DEFAULT}
                      target={"_blank"}
                    > */}
                    <button className="upgrade-subscription-btn"
                      onClick={() => {
                        this.setState({ showCancelModal: true })
                      }}
                      style={{ backgroundColor: " rgba(0, 0, 0, 0.12)", color: "#000" }}><span>Cancel Subscription</span></button>

                    {/* </a> */}
                  </div>
                  {this.state.modalVisible && <ViewModal
                    open={this.state.modalVisible}
                    handleClose={() => this.setState({ modalVisible: false })}
                    modalContent={{ ...this.state.modalContent, id: this.state.modalContent?.membership?.id }}
                    selectedTab={1}
                    isDirector={true}
                  />}
                  <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={this.state.upgradePlan}
                    onClose={() => this.setState({ upgradePlan: false })}
                    closeAfterTransition={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                      timeout: 500,
                    }}
                  >
                    <Fade in={this.state.upgradePlan}>
                      <div className={classes.paper}>
                        <h2 id="transition-modal-title">Modal Title</h2>
                        <p id="transition-modal-description">Some description or content here.</p>
                        <Button onClick={() => this.setState({ upgradePlan: false })} variant="contained" color="secondary">
                          Close
                        </Button>
                      </div>
                    </Fade>
                  </Modal>
                </div>
                <CancelModal open={this.state.showCancelModal} handleClose={() => { this.setState({ showCancelModal: false }) }} handleOk={() => {
                  this.setState({ showCancelModal: false })
                  window.open(ZENDESK_CANCEL_SUBSCRIPTION)
                }}
                  positiveText={"Cancel"}
                  title={"Cancel Subscription"}
                  description={"If you cancel now, you'll retain access until the end date, but no refunds will be issued."}
                />
                <PlanOptions
                  open={this.state.showDescription}
                  handleClose={() => {
                    this.setState({ showDescription: false })
                  }}
                  description={this.state.description}
                />
              </Page>
            );
          }


        }
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/subscriptionHistory/index.tsx